


























































































































































































































































































import Vue from "vue";
import assignRequestDataProvider from "@/services/assign-request/defaultDataProvider";
import moment from "moment";
import { nanoid } from "nanoid";
import { validate } from "@vuetifyx/utils/validate";
import ViewDetail from "../assign-request/partials/ViewDetail.vue";
const dataProvider = assignRequestDataProvider();

Vue.filter("dateFormat", (value, format = "HH:mm:ss - DD/MM/YYYY") => {
  return moment(value * 1000).format(format);
});

export default Vue.extend({
  props: ["showDialog"],
  components: {
    ViewDetail,
  },
  data() {
    return {
      submiting: false,
      detailDialog: false,
      itemDetail: {},
      selectedRowId: [],
      assignRequestCancelId: "",
      dialogDelete: false,
      editedIndex: -1,
      error: "",
      rules: {
        required: (value) => {
          if (!value || value.replace(/ /g, "") === "") {
            return false || "Required"
          }
          return true || ""
        },
        // ipDomainRequired: (value) => {
        //   return (
        //     validate.validateIPaddress(value) ||
        //     validate.validateDomain(value) ||
        //     "The IP/Host/Domain field must be a valid domain or ip/host address."
        //   );
        // },
        // portRequired: (value) => {
        //   return (
        //     validate.validatePortNumber(value) ||
        //     "The Port field must be a valid port number."
        //   );
        // },
      },
      dialog: false,
      formData: {
        requested_destinations: [
          {
            ip_def: "",
            port_def: "",
            type: "Tcp",
          },
        ],
      },
      search: "",
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: "Message",
          sortable: false,
          value: "message",
        },
        {
          text: "Destination",
          sortable: false,
          value: "destination",
        },
        {
          text: "Processed by",
          sortable: false,
          value: "decision_admin",
        },
        {
          text: "Admin message",
          sortable: false,
          value: "decision_admin_message",
        },
        {
          text: "Processed time",
          sortable: false,
          value: "decision_time",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
        },
        {
          text: "Action",
          align: "end",
          value: "action",
          sortable: false,
        },
      ],
      dataTable: [],
    };
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            document.querySelector("input").focus();
          }, 100);
        }
      },
      deep: true,
    },
    showDialog: {
      handler(val) {
        this.dialog = val;
      },
      deep: true,
    },
    'formData.requested_destinations': {
      async handler(val) {
        if (val[val.length - 1].ip_def !== "" || val[val.length - 1].port_def !== "") {
          await this.addMoreDestination()
        }
      },
      deep: true
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New request"
        : "Edit request";
    },
  },
  methods: {
    viewDetail(item) {
      this.itemDetail = item;
      this.detailDialog = true;
    },
    removeDestination(index) {
      if (index >= 0) {
        this.formData.requested_destinations.splice(index, 1);
      }
    },
    onRowClick(item) {
      const index = this.selectedRowId.findIndex(
        (id) => id === item.assign_request_id
      );
      if (index > -1) {
        this.selectedRowId.splice(index, 1);
      } else {
        this.selectedRowId.push(item.assign_request_id);
      }
    },
    popupCancelAssignRequest(item) {
      this.dialogDelete = true;
      this.assignRequestCancelId = item.assign_request_id;
    },
    async cancelAssignRequest() {
      const params = {
        ["value"]: this.assignRequestCancelId,
        body: {
          value: this.assignRequestCancelId,
        },
      };
      try {
        const { data } = await dataProvider.execute("AssignRequestCancel", params);
        if (data) {
          await this.getData();
          this.dialogDelete = false;
        } else if (data.message) {
          this.error = data.message;
        }
      } catch (error) {
        this.error = error;
      }
    },
    editAssignRequest(item) {
      this.editedIndex = this.dataTable.indexOf(item);
      this.formData = Object.assign({}, item);
      if (item.requested_destinations && item.requested_destinations.length > 0) {
        this.formData.requested_destinations = JSON.parse(
          JSON.stringify(item.requested_destinations)
        );
      }
      setTimeout(() => {
        this.dialog = true;
      }, 500)
    },
    async submit() {
      try {
        let operationId;
        this.submiting = true;
        const dataQuery = Object.assign({}, this.formData);
        dataQuery.requested_destinations.splice(Number(dataQuery.requested_destinations.length) - 1, 1)
        const params = {
          body: {
            data: dataQuery,
          },
        };
        if (this.editedIndex > -1) {
          params["data.assign_request_id"] = dataQuery.assign_request_id;
          operationId = "AssignRequestUpdate";
        } else {
          operationId = "AssignRequestCreate";
        }
        const { data } = await dataProvider.execute(operationId, params);
        if (data) {
          this.closeDialog();
          this.submiting = false
          await this.getData();
        } else if (data.message) {
          this.error = data.message;
        }
      } catch (error) {
        this.error = error;
      }
    },
    closeDialog() {
      if (this.$refs["card-base"].$children[0].$children[0]) {
        this.$refs["card-base"].$children[0].$children[0].reset();
      }
      this.dialog = false;
      this.$emit("closeDialogRequest");
      this.$nextTick(() => {
        this.formData = Object.assign(
          {},
          {
            requested_destinations: [
              {
                ip_def: "",
                port_def: "",
                type: "Tcp",
              },
            ],
          }
        );
        this.editedIndex = -1;
      });
    },
    addMoreDestination() {
      if (this.submiting) {
        return;
      }
      this.formData.requested_destinations.push({
        ip_def: "",
        port_def: "",
        type: "Tcp",
      });
      // setTimeout(() => {
      //   const form = document.getElementsByClassName(
      //     "application-request-detail"
      //   );
      //   const input = form[form.length - 1].querySelector("input").focus();
      // }, 100);
    },
    async getData() {
      const params = {
        request_payload: JSON.stringify({
          offset: 0,
          limit: 30,
          orders: {
            created_time: 1,
          },
          search: "",
          filters: [],
          extra_params: {},
        }),
      };
      const { body } = await dataProvider.execute("AssignRequestGetAllByUserId", params);
      if (body && body.data && body.data.length > 0) {
        this.dataTable = body.data;
      }
    },
    getStatusRequestDestination(item, destination) {
      for (const app of item.temp_data.temp_apps) {
        if (app.requested_destination_local_ids.includes(destination.local_id) && item.status.toLowerCase() === 'approved') {
          return "Granted";
        }
      }
      return "Not granted";
    },
  },
  created() {
    this.getData();
  },
});
